/**
 * Lightweight i18n plugin for BizOps Registration.
 * Loads locale JSON files lazily (one webpack chunk per language).
 * Provides Vue.prototype.$t(key) with automatic English fallback.
 * Provides Vue.prototype.$loadLocale(lang) — returns a Promise.
 * English and the initial saved language are preloaded in main.js
 * before the Vue instance mounts.
 *
 * Supported languages: en, hinglish, hi
 */

const localeLoaders = {
  en:       () => import('../locales/en.json'),
  hinglish: () => import('../locales/hinglish.json'),
  hi:       () => import('../locales/hi.json')
}

const localeCache = {}
const pendingLoads = {}

function loadLocale (lang) {
  if (localeCache[lang]) return Promise.resolve(localeCache[lang])
  if (pendingLoads[lang]) return pendingLoads[lang]
  if (!localeLoaders[lang]) {
    console.warn('[i18n] No loader for language:', lang)
    return Promise.resolve({})
  }
  pendingLoads[lang] = localeLoaders[lang]()
    .then(function (module) {
      localeCache[lang] = module.default || module
      delete pendingLoads[lang]
      return localeCache[lang]
    })
    .catch(function (err) {
      console.error('[i18n] Failed to load locale:', lang, err)
      delete pendingLoads[lang]
      return {}
    })
  return pendingLoads[lang]
}

function getByPath (obj, path) {
  return path.split('.').reduce(function (curr, key) {
    return curr !== null && curr !== undefined ? curr[key] : undefined
  }, obj)
}

const i18nPlugin = {
  install: function (Vue) {
    Vue.prototype.$loadLocale = loadLocale

    Vue.prototype.$t = function (key) {
      var lang = (this.$root && this.$root.selectedLanguage) || 'en'
      var messages = localeCache[lang]
      if (messages) {
        var val = getByPath(messages, key)
        if (val !== undefined && val !== null) return val
      }
      var enMessages = localeCache['en'] || {}
      var fallback = getByPath(enMessages, key)
      return (fallback !== undefined && fallback !== null) ? fallback : key
    }
  }
}

export { loadLocale, localeCache }
export default i18nPlugin
